import { addModelFiles } from './communication-attachment.js';
import { toggleCard } from '@core/toggle-card.js';
import datatable from '@core/component/datatable/datatable.js';


export function communicationRecipientsTable() {
    return datatable({
        columnDefs: [
            {width: '110px', targets: [1]},
            {width: '150px', targets: 'col-comm-sms'},
            {width: '100px', targets: 'col-comm-portal'},
        ]
    });
}

export default () => ({
    async init() {
        initCommunicationModal(this.$el, this.$refs)
    }
});

function initCommunicationModal(el, refs) {

    // Gestion de la sélection de modèle
    initModelSelectors();

    function initModelSelectors() {
        const emailCard = el.querySelector('[x-ref="emailCard"]');
        const smsCard = el.querySelector('[x-ref="smsCard"]');
        const portalCard = el.querySelector('[x-ref="portalCard"]');

        const emailSelect = emailCard?.querySelector('[x-ref="modelSelect"]');
        const smsSelect = smsCard?.querySelector('[x-ref="modelSelect"]');
        const portalSelect = portalCard?.querySelector('[x-ref="modelSelect"]');

        if (emailSelect) {
            emailSelect.addEventListener('change', (e) => handleModelSelection(e, 'email'));
        }
        if (smsSelect) {
            smsSelect.addEventListener('change', (e) => handleModelSelection(e, 'sms'));
        }
        if (portalSelect) {
            portalSelect.addEventListener('change', (e) => handleModelSelection(e, 'portal'));
        }
    }

    async function handleModelSelection(event, channel) {
        const modelId = event.target.value;
        if (!modelId) return;

        // Vérifier si des données ont déjà été saisies
        const hasData = checkIfDataEntered(channel);

        if (hasData) {
            const confirmed = confirm(getMessage('kibe.communication.modal.confirm.replace_data'));
            if (!confirmed) {
                // Réinitialiser le sélecteur
                event.target.value = '';
                return;
            }
        }

        // Charger le modèle
        try {
            const response = await fetch(window.NEXT_URL + `/communication/api/model/${modelId}`);
            if (response.ok) {
                const modelData = await response.json();
                applyModelContent(modelData, channel);
            } else {
                alert(getMessage('kibe.communication.modal.error.load_model'));
            }
        } catch (error) {
            console.error('Error loading model:', error);
            alert(getMessage('kibe.communication.modal.error.load_model'));
        }
    }

    function checkIfDataEntered(channel) {
        if (channel === 'email') {
            const card = el.querySelector('[x-ref="emailCard"]');
            const subject = card?.querySelector('[x-ref="messageSubject"]');
            const bodyEl = card?.querySelector('[x-ref="messageBody"]');
            const editor = bodyEl?._tiptapEditor;
            const hasBody = editor ? !editor.isEmpty : bodyEl?.value?.trim();
            return (subject && subject.value.trim()) || hasBody;
        } else if (channel === 'sms') {
            const card = el.querySelector('[x-ref="smsCard"]');
            const body = card?.querySelector('[x-ref="messageBody"]');
            return body && body.value.trim();
        } else if (channel === 'portal') {
            const card = el.querySelector('[x-ref="portalCard"]');
            const subject = card?.querySelector('[x-ref="messageSubject"]');
            const bodyEl = card?.querySelector('[x-ref="messageBody"]');
            const editor = bodyEl?._tiptapEditor;
            const hasBody = editor ? !editor.isEmpty : bodyEl?.value?.trim();
            return (subject && subject.value.trim()) || hasBody;
        }
        return false;
    }

    function applyModelContent(modelData, channel) {
        if (channel === 'email') {
            const card = el.querySelector('[x-ref="emailCard"]');
            const subject = card?.querySelector('[x-ref="messageSubject"]');
            const bodyEl = card?.querySelector('[x-ref="messageBody"]');
            const editor = bodyEl?._tiptapEditor;
            if (subject && modelData.emailSubject) {
                subject.value = modelData.emailSubject;
            }
            if (editor && modelData.emailBody) {
                editor.commands.setContent(modelData.emailBody);
            }
            if (modelData.emailAttachments) {
                const zone = card?.querySelector('[x-ref="attachments"]');
                const list = zone?.querySelector('.file-list');
                if (list) {
                    addModelFiles(modelData.emailAttachments, list, channel);
                }
            }
        } else if (channel === 'sms') {
            const card = el.querySelector('[x-ref="smsCard"]');
            const body = card?.querySelector('[x-ref="messageBody"]');
            if (body && modelData.smsBody) {
                body.value = modelData.smsBody;
            }
        } else if (channel === 'portal') {
            const card = el.querySelector('[x-ref="portalCard"]');
            const subject = card?.querySelector('[x-ref="messageSubject"]');
            const bodyEl = card?.querySelector('[x-ref="messageBody"]');
            const editor = bodyEl?._tiptapEditor;
            if (subject && modelData.portalSubject) {
                subject.value = modelData.portalSubject;
            }
            if (editor && modelData.portalBody) {
                editor.commands.setContent(modelData.portalBody);
            }
            if (modelData.portalAttachments) {
                const zone = card?.querySelector('[x-ref="attachments"]');
                const list = zone?.querySelector('.file-list');
                if (list) {
                    addModelFiles(modelData.portalAttachments, list, channel);
                }
            }
        }
    }
}
